import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import {isEnglish} from '../../localization/language-cookie';

export default class ArchivePageContainer extends AppContainer {
    getContent() {
        return isEnglish()
            ? window.CARE_CONFIG.settings.archive_text_en
            : window.CARE_CONFIG.settings.archive_text;
    }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.archive)}>
                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.archive}</span>
                        </h1>
                        <div className="post-body" dangerouslySetInnerHTML={{
                            __html: this.getContent()
                        }}></div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/pages/archive-page-container.js